export const BRAND = {
  name: "Virtue Registration Services",
  shortName: "Virtue Registrations",
  tagline: "Fast. Simple. Done Right.",
  subTagline:
    "We take care of the paperwork, so you can skip the stress — and the DMV lines.",
  phone: "619-230-5053",
  phoneHref: "tel:+16192305053",
  email: "info@virtueregistrations.com",
  emailHref: "mailto:info@virtueregistrations.com",
  address: "2509 El Cajon Blvd #A, San Diego, CA 92104",
  mapsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=2509+El+Cajon+Blvd+%23A%2C+San+Diego%2C+CA+92104",
  hours: [
    { day: "Mon – Fri", time: "9:00 AM – 6:00 PM" },
    { day: "Saturday", time: "10:00 AM – 1:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  logo:
    "https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/OJ0RFMT31SxM47DHOvsM/media/69a393b6167da41d2b8a2a00.png",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "Book", href: "#book" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    value: "registration-renewal",
    label: "Registration Renewal",
    blurb:
      "Renew on time and avoid late fees. We process renewals same-day for most vehicles.",
    icon: "RotateCw",
  },
  {
    value: "sticker-replacement",
    label: "Lost or Stolen Sticker Replacement",
    blurb:
      "Lost a tag or sticker? Walk in, walk out with a new one — no DMV appointment needed.",
    icon: "Sticker",
  },
  {
    value: "card-replacement",
    label: "Registration Card Replacement",
    blurb:
      "Replace a lost, damaged, or stolen registration card without the wait.",
    icon: "IdCard",
  },
  {
    value: "title-transfer-instate",
    label: "Title Transfer (In-State)",
    blurb:
      "Buying or selling within California? We handle the title transfer end-to-end.",
    icon: "FileCheck",
  },
  {
    value: "title-transfer-outstate",
    label: "Title Transfer (Out-of-State)",
    blurb:
      "New to California? We move your registration over cleanly and compliantly.",
    icon: "MapPinned",
  },
  {
    value: "vin-verification",
    label: "VIN Verification",
    blurb:
      "Certified VIN verification on-site. Required for out-of-state and special vehicles.",
    icon: "ScanLine",
  },
  {
    value: "duplicate-title",
    label: "Duplicate Title Request",
    blurb:
      "Need a duplicate title? We file directly with the DMV — fast and accurately.",
    icon: "FileStack",
  },
  {
    value: "ownership-transfer",
    label: "Transfer of Ownership",
    blurb:
      "Gifts, inheritance, business transfers — we manage the paperwork properly.",
    icon: "Users",
  },
  {
    value: "commercial-registration",
    label: "Commercial Vehicle Registration",
    blurb:
      "Trucks, fleets, and commercial plates — keep your business moving.",
    icon: "Truck",
  },
];

export const TESTIMONIALS = [
  {
    name: "Maria G.",
    role: "San Diego, CA",
    rating: 5,
    text:
      "I dreaded the DMV. Walked into Virtue, was out in 15 minutes with my renewal done. Lifesaver.",
  },
  {
    name: "Jason R.",
    role: "Out-of-state transfer",
    rating: 5,
    text:
      "Moved from Texas. They handled the title transfer, VIN verification, and California registration in one visit.",
  },
  {
    name: "Priya S.",
    role: "Small business owner",
    rating: 5,
    text:
      "Registered three commercial vehicles for my company. Honest pricing, no surprises, super professional.",
  },
  {
    name: "Daniel K.",
    role: "First-time buyer",
    rating: 5,
    text:
      "I bought a used car privately and had no idea what to do. They walked me through everything calmly.",
  },
  {
    name: "Elena V.",
    role: "El Cajon Blvd local",
    rating: 5,
    text:
      "Friendly, fluent in Spanish, and incredibly fast. I send everyone in my family here now.",
  },
];

export const FAQS = [
  {
    q: "What services do you provide?",
    a: "We handle a wide range of DMV-related services — registration renewals, title transfers (in-state and out-of-state), replacement registration cards, duplicate titles, VIN verifications, transfer of ownership, and lost or stolen sticker replacements. Our goal is to save you time and help you avoid long DMV lines.",
  },
  {
    q: "Do I need an appointment?",
    a: "Appointments are recommended to guarantee quick service, but we also accept walk-ins when availability allows. Scheduling ahead lets us prepare your paperwork so you're in and out faster.",
  },
  {
    q: "How long does a typical service take?",
    a: "Most transactions are completed in one visit, often within 15–30 minutes. More complex transactions may take a bit longer, but we work efficiently to minimize your wait.",
  },
  {
    q: "What documents do I need for a title transfer?",
    a: "Typically you'll need the signed title, a valid government-issued ID, proof of insurance, and payment for applicable fees. Out-of-state transfers may require a VIN verification. Call us first and we'll confirm exactly what to bring.",
  },
  {
    q: "Are your fees the same as the DMV?",
    a: "State fees are set by the DMV and are the same everywhere. As a private registration service, we charge a service fee for processing and handling — that's what saves you the DMV trip. We're always transparent about pricing up front.",
  },
  {
    q: "What types of vehicles do you service?",
    a: "All vehicles — passenger cars, motorcycles, RVs, trailers, and commercial vehicles. If you're unsure, just give us a call.",
  },
];
